import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "../http/http.service";

@Injectable({
    providedIn: "root",
})
export class DocumentsHttpService {
    /**
     * The documents base url
     * @private
     * @readonly
     */
    private readonly _documentsBaseUrl: string = "documents";

    constructor(private _httpService: HttpService) {}

    /**
     * @public Get Open Api Schema
     * @returns an Observable{object} with the open api schema
     */
    public getOpenApiSchema(): Observable<object> {
        return this._httpService.get<object>(this._documentsBaseUrl);
    }

    /**
     * @public Get changelog.md file
     * @returns an Observable{string} with document content returned from server
     */
    public getChangelogFile(): Observable<string> {
        const url = `${this._documentsBaseUrl}/changelog`;
        return this._httpService.get<string>(url);
    }
}
